module.exports = __webpack_public_path__ + "static/media/vehicleSVG.a7e079bb.svg";